import script from "./TextColorButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextColorButton.vue?vue&type=script&lang=ts&setup=true"

import "./TextColorButton.vue?vue&type=style&index=0&id=c90c8a28&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c90c8a28"]])

export default __exports__